'use client';

import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { ContentWrap, Css, H3, Responsive } from '../../../../ui';
import Subheading from '../../../../components/common/headings/Subheading';
import { Color } from '../../../../styles/Color';
import { QuickLink } from '../../../../components/common/quick-links/QuickLink';
import ViewButton from '../../../../components/common/button/TextAndButton';
import { PageRoutes } from '../../../app/pages/domain/constants/PageRoutes';

interface IProps {
	title?: string;
	subtitle?: string;
	addDarkBackground?: boolean;
	forceViewAllButtonAsText?: boolean;
	children: ReactNode;
	viewAllHref?: string;
}

export default function NewsSectionWrapper({
	title,
	subtitle,
	addDarkBackground,
	forceViewAllButtonAsText,
	children,
	viewAllHref = PageRoutes.CorporateNewsroomNews,
}: IProps) {
	const isMobileXL = Responsive.useMatchesBreakpoint('mobileXL');
	const label = 'View all';

	return (
		<SectionWrapper addDarkBackground={addDarkBackground}>
			<ContentWrap>
				<SectionTop>
					{!title && subtitle && <Subheading type="h3">{subtitle}</Subheading>}

					{title && (
						<H3 styling="h4">
							{subtitle && <Subheading type="h3">{subtitle}</Subheading>}
							{title}
						</H3>
					)}

					{isMobileXL || forceViewAllButtonAsText ? (
						<QuickLink type="internal" url={viewAllHref} ariaLabel={label}>
							{label}
						</QuickLink>
					) : (
						<ViewButton label={label} href={viewAllHref} />
					)}
				</SectionTop>
				{children}
			</ContentWrap>
		</SectionWrapper>
	);
}

export const SectionWrapper = styled.div<{
	addDarkBackground?: boolean;
}>`
	flex-grow: 1;
	${({ addDarkBackground }) =>
		addDarkBackground && `background-color: ${Color.Neutral2};`}
	padding: ${Css.pxToRem(100)} 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: ${Css.pxToRem(40)} 0;
	}
`;

const SectionTop = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-end;
	margin-bottom: ${Css.pxToRem(24)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-bottom: ${Css.pxToRem(16)};

		span {
			font-size: ${Css.pxToRem(14)};
			margin-bottom: ${Css.pxToRem(4)};
		}

		a {
			padding: 0;
			padding-bottom: ${Css.pxToRem(4)};
		}
	}

	h3 {
		margin-bottom: 0;
		line-height: normal;

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			font-size: ${Css.pxToRem(32)};
		}
	}
`;
